export const compress = (base64, quality = 200, mimeType = 'image/jpg') => {
  const MAX_WIDTH = 560;
  const cvs = document.createElement('canvas');
  const img = document.createElement('img');
  img.crossOrigin = 'anonymous';
  return new Promise(resolve => {
    img.src = base64;
    img.onload = () => {
      if (img.width > MAX_WIDTH) {
        cvs.width = MAX_WIDTH;
        cvs.height = (img.height * MAX_WIDTH) / img.width;
      } else {
        cvs.width = img.width;
        cvs.height = img.height;
      }
      cvs.getContext('2d').drawImage(img, 0, 0, cvs.width, cvs.height);
      const imageData = cvs.toDataURL(mimeType, quality / 1000);
      resolve(imageData);
    };
  });
};

export const data = () => {};
